class NewsletterPopup extends HTMLElement {
  static STORAGE_KEY = 'hijamaiy-newsletter-popup';

  connectedCallback() {
    this.dialog = this.querySelector('.newsletter-popup__dialog');
    this.delay = parseInt(this.dataset.delay || '4000', 10);
    this.reappearDays = parseFloat(this.dataset.reappearDays || '7');

    this.querySelectorAll('[data-npu-dismiss]').forEach((el) => {
      el.addEventListener('click', () => this.dismiss());
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.classList.contains('is-visible')) this.dismiss();
    });

    if (this.querySelector('[data-npu-success]')) {
      this.show();
      this.remember(365);
      return;
    }

    if (this.shouldShow()) {
      window.setTimeout(() => this.show(), this.delay);
    }
  }

  shouldShow() {
    try {
      const raw = window.localStorage.getItem(NewsletterPopup.STORAGE_KEY);
      if (!raw) return true;
      const { until } = JSON.parse(raw);
      return !until || Date.now() > until;
    } catch (error) {
      return true;
    }
  }

  remember(days) {
    try {
      const until = Date.now() + days * 24 * 60 * 60 * 1000;
      window.localStorage.setItem(NewsletterPopup.STORAGE_KEY, JSON.stringify({ until }));
    } catch (error) {
      /* localStorage unavailable */
    }
  }

  show() {
    this.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    const firstInput = this.querySelector('input');
    if (firstInput) window.requestAnimationFrame(() => firstInput.focus({ preventScroll: true }));
  }

  dismiss() {
    this.classList.remove('is-visible');
    document.body.style.overflow = '';
    this.remember(this.reappearDays);
  }
}

customElements.define('newsletter-popup', NewsletterPopup);
